export default "Diagnostic CEE Copropriété — Estimez vos primes travaux collectifs | Solution Éco France";
